import script from "./UserMailLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMailLogin.vue?vue&type=script&setup=true&lang=js"

import "./UserMailLogin.vue?vue&type=style&index=0&id=8b0a5926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0a5926"]])

export default __exports__